import { render, staticRenderFns } from "./MenuFooter.vue?vue&type=template&id=0ab14e0d&lang=html&"
import script from "./MenuFooter.vue?vue&type=script&lang=ts&"
export * from "./MenuFooter.vue?vue&type=script&lang=ts&"
import style0 from "./MenuFooter.vue?vue&type=style&index=0&id=0ab14e0d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports